// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-b8022914]{margin:0 auto;width:calc(var(--inner-width)*1px)}.title[data-v-b8022914]{padding-bottom:0;font-weight:700;color:var(--main-theme-color)}[data-v-b8022914] .el-divider{background-color:var(--main-theme-color)}", ""]);
// Exports
module.exports = exports;
